import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { CardHeader } from "../../../components/cards";
import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";

import { useSentinel } from "../hooks";

type ISentinelParams = {
  id: string;
};

export const Sentinel: React.FC = () => {
  const { id } = useParams<ISentinelParams>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/sentinels");
    }
  }, []);

  const { data } = useSentinel(+id!);

  return (
    <>
      <Header
        title={`Sentinel`}
        subtitle={`${data?.sentinel?.result?.ip}`}
        buttons={[
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/payment/${id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <section className="section ">
          <div className=" element">
            <div className="card">
              <CardHeader title={data?.sentinel?.result?.name ?? ""} />
            </div>
          </div>

          <div className="element">
            <div className="card"></div>
          </div>
        </section>
      </div>
    </>
  );
};
